import { render, staticRenderFns } from "./DropdownRole.vue?vue&type=template&id=72fcb6fc&scoped=true"
import script from "./DropdownRole.vue?vue&type=script&lang=js"
export * from "./DropdownRole.vue?vue&type=script&lang=js"
import style0 from "./DropdownRole.vue?vue&type=style&index=0&id=72fcb6fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fcb6fc",
  null
  
)

export default component.exports